namespace Matrix.Data {
    export class SecurityRepairLogColumns {
        static columnsKey = 'Data.SecurityRepairLog';
    }
}
